import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Link
          to="/"
          className="text-sm text-blue-500 hover:underline"
        >
          ← Back to RushGro
        </Link>

        <h1 className="text-4xl font-bold mt-6 mb-2">
          Privacy Policy
        </h1>

        <p className="text-muted-foreground mb-10">
          Last updated: 24 August 2026
        </p>

        <div className="space-y-8 text-sm leading-7">
          <section>
            <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
            <p>
              This Privacy Policy explains how RushGro collects, uses, stores,
              processes, and protects personal and business information when
              users access the RushGro website, dashboard, applications,
              Power Backup as a Service platform, IoT-enabled energy assets,
              support services, and related services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              2. Information We Collect
            </h2>
            <p>We may collect information including:</p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Name, email address, phone number, company name and designation.</li>
              <li>Account login and authentication information.</li>
              <li>Brand, outlet and business location information.</li>
              <li>Subscription, invoice and payment-related information.</li>
              <li>Asset installation, maintenance and warranty information.</li>
              <li>
                IoT and device information including device ID, connectivity
                status, charging/discharging status and operational data.
              </li>
              <li>Customer support communications and service requests.</li>
              <li>
                Technical data such as IP address, browser information,
                session information and application logs.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              3. How We Use Information
            </h2>
            <p>We may use collected information to:</p>
            <ul className="list-disc pl-6 mt-3 space-y-2">
              <li>Create and manage user and business accounts.</li>
              <li>Provide and manage RushGro subscriptions and services.</li>
              <li>Install, monitor and maintain energy backup assets.</li>
              <li>Provide dashboards, reports and IoT monitoring services.</li>
              <li>Process subscriptions, invoices and payments.</li>
              <li>Provide customer support and maintenance assistance.</li>
              <li>Improve platform security and prevent fraud or misuse.</li>
              <li>Comply with applicable legal and regulatory requirements.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              4. Cookies and Authentication
            </h2>
            <p>
              RushGro may use cookies and similar technologies for secure
              authentication, session management, platform functionality,
              analytics and security. Authentication cookies may be protected
              using security attributes such as HttpOnly and Secure.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              5. IoT and Device Data
            </h2>
            <p>
              RushGro may process operational data generated by connected
              energy assets and third-party IoT platforms. This data may be
              used for asset monitoring, maintenance, service availability,
              diagnostics, reporting and operational management.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              6. Third-Party Service Providers
            </h2>
            <p>
              RushGro may use third-party technology and infrastructure
              providers for cloud hosting, databases, IoT integrations,
              communications, payments, analytics and other operational
              services. Information may be processed by such providers only
              as necessary to provide the relevant services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              7. Data Security
            </h2>
            <p>
              We take reasonable administrative and technical measures to
              protect information from unauthorized access, loss, misuse,
              alteration or disclosure. However, no internet-based system can
              guarantee absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              8. Data Retention
            </h2>
            <p>
              Information may be retained for as long as necessary to provide
              our services, maintain business and legal records, resolve
              disputes, enforce agreements and comply with applicable law.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              9. Your Rights
            </h2>
            <p>
              Subject to applicable law, users may request access,
              correction or deletion of certain personal information or raise
              questions regarding the processing of their information.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">
              10. Changes to This Policy
            </h2>
            <p>
              RushGro may update this Privacy Policy from time to time.
              Updated versions will be published on this page with a revised
              effective date.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3">11. Contact Us</h2>
            <p>
              For privacy-related questions, contact:
            </p>

            <p className="mt-3">
              <strong>RushGro</strong><br />
              Email: support@rushgro.com<br />
              Website: rushgro.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}